<template>
    <div>
        <PrintProperties
            :internalCode="internalCode"
            :panelID="panelID"
            :title="title"
            :forceFallback="false"
            :showZoomToFeatures="false"
            :showLayout="false"
            :showFormat="false"
            name="print-visible-properties"
        />
    </div>
</template>

<script>

    export default {
        name: 'ManagePrintVisibleProperties',
        components: {
            PrintProperties: () => import(/* webpackChunkName: "print-properties" */ './ManagePrintProperties'),
        },
        props: {
            internalCode: {
                type: String,
                require: true,
            },
            panelID: {
                type: String,
                default: 'print_visible_emissions',
            },
            title: {
                type: String,
                default: ''
            },
        },
        data() {
            return {

            }
        },
    }
</script>

<style scoped lang="scss">
</style>